import { useMutation, gql } from '@apollo/client';

export const DELETE_MAD_DOCUMENT = gql`
  mutation useDeleteMadDocument($input: DeleteMadDocumentInput!) {
    deleteMadDocument(input: $input) {
        id
    }
  }
`;

export default (options) => {
  return (
    useMutation(DELETE_MAD_DOCUMENT, options)
  );
}
